import module from '../module';

function HeapService() {
    return {
        identify: function () {
            try {
                window.heap.identify.apply(null, arguments);
            } catch (e) {
            }
        },
        track: function (name, obj) {
            try {
                window.heap.track.apply(null, arguments);
            } catch (e) {
            }
        }
    };
}

module.factory('HeapService', HeapService);



// WEBPACK FOOTER //
// ./src/modules/shared/services/HeapService.js